import { PhaserUtils } from "../../utils/PhaserUtils"

export enum MakeVaperImages {
    BACKGROUND = "background.png",
    BIB = "bib.png",
    BORED_POTATOES = "bored-potatoes.png",
    BUFF_ARMS = "buff-arms.png",
    DUNCE = "dunce.png",
    EXCITED_POTATOES = "excited-potatoes.png",
    HAPPY_POTATOES = "happy-potatoes.png",
    SAD_POTATOES = "sad-potatoes.png",
    SMART = "smart.png",
    SPUD = "spud.png",
    SUNGLASSES = "sunglasses.png",
    WEAK_ARMS = "weak-arms.png"
}

export function loadSharedAssets(game: Phaser.Game) {
    const loader = PhaserUtils.makeLoader(game, "make-vaper")
    loader.autoLoad({imageEnum: MakeVaperImages})
}
